<template>
	<div>
		<Select v-model="selectedVal" @on-change="selectChange">
			<Option v-for="item in payWayOptionList" :value="item.key" :key="item.key">
				{{ item.key }}
			</Option>
		</Select>
		<Button @click="payWayConfigModal = true;">
			<Icon type="ios-settings-outline" size='18'/>
		</Button>
		<Modal v-model="payWayConfigModal" draggable sticky scrollable>
			<p slot="header" style="text-align:left">
				<Icon type="ios-create-outline" size='18'/>
				<span> 添加付款方式</span>
			</p>
			<div style="width:100%;padding:5px;background-color:#fff;border-radius:5px;height:300px;overflow:auto;">
				<table style="width:100%;">
					<tr>
						<td style="width:50%;">
							<Input v-model="payWayFormItem.key" placeholder="请输入显示名" />
						</td>
						<td style="width:50%;" colspan="2">
							<Input v-model="payWayFormItem.value" placeholder="请输入编号"
								@keyup.enter.native="addPayWay()" />
						</td>
					</tr>
					<tr>
						<td class="tab-hander">显示名</td>
						<td class="tab-hander">编号</td>
						<td class="tab-hander" style="text-align:center;">操作</td>
					</tr>
					<tr v-for="item in payWayOptionList">
						<td>{{item.key}}</td>
						<td>{{item.value}}</td>
						<td style="text-align:center;">
							<Icon type="md-trash" size='18' class="icon-item-dele" @click.stop="delePayWay(item.id)"/>
						</td>
					</tr>
				</table>
			</div>
			<div slot="footer">
				<button class="jxyd-button" @click="payWayConfigModal = false;">关闭</button>
				<Button class="jxyd-button jxyd-primary" @click="addPayWay()">保存</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		name: 'SelectTradeMethod',
		props: ['value','accountPid'],
		data() {
			return {
				selectedVal:'',
				payWayOptionList: [],
				payWayConfigModal: false,
				payWayFormItem: {
					id: 0,
					key: '',
					value: '',
					pid: 0,
					pcode:'',
					creator: parseInt(localStorage.getItem("userId"))
				},
			}
		},
		methods: {
			initPayWayOptionList() {
				let self = this;
				//获取收付款账户数据字典
				request.get('/api/DataDictionary/GetDataDictionaryList', {
					params: {
						code: this.accountPid
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取收付款账户数据失败：" + response.errorMsg
						});
						return;
					}
					self.payWayOptionList = response.data;
				}).catch(function(error) {})
			},
			addPayWay() {
				if (!this.payWayFormItem.key) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '显示名不可为空!'
					});
					return;
				}
				if (!this.payWayFormItem.value) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: '编号不可为空!'
					});
					return;
				}
				this.payWayFormItem.pcode = this.accountPid;
				let self = this;
				request.post('/api/DataDictionary/AddDataDictionary', this.payWayFormItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}
			
					self.initPayWayOptionList();
					self.payWayFormItem.key = '';
					self.payWayFormItem.value = '';
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});
			
				}).catch(function(error) {})
			},
			delePayWay(id) {
				var self = this;
				request.post('/api/DataDictionary/DeleDataDictionary', [id]).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initPayWayOptionList();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '删除成功!'
					});
				}).catch(function(error) {})
			},
			selectChange(val){
				this.$emit('update:value', val);
			}
		},
		watch:{
			value(val){
				this.selectedVal = val;
			}
		},
		created: function() {
			this.initPayWayOptionList();
		},
	}
</script>

<style scoped>
	/deep/ .ivu-select{
		width: auto;
	}
	
	.icon-item-dele {
		cursor: pointer;
	}
	
	.icon-item-dele:hover {
		transform: scale(1.3);
	}
</style>